<template>
  <div>
    <el-form style="width: 500px" label-width="100px" :model="formData" ref="form">


      <el-form-item :label="$t('lang.难易水平')" prop="difficultyLevel" required>
        <el-select :disabled="disabled" v-model="formData.difficultyLevel" :placeholder="$t('lang.请选择')">
          <el-option :label="$t('lang.容易')" value="easy"></el-option>
          <el-option :label="$t('lang.中等')" value="medium"></el-option>
          <el-option :label="$t('lang.困难')" value="hard"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.选择标签')" prop="tags">
        <div style="display: flex;column-gap: 16px">
          <el-select :disabled="disabled" v-model="formData.tags" multiple>
            <el-option v-for="tag in recipeTagList" :key="tag.recipeTagCode" :label="tag.name" :value="tag.recipeTagCode" />
          </el-select>
          <el-link :underline="false" style="color: #2f86dd;" @click="$router.push('/tag-add')"  v-if="!disabled">{{$t('lang.新增标签')}}</el-link>
        </div>

      </el-form-item>

<!--      <el-form-item :label="$t('lang.兼容型号')" required>-->
<!--        <div class="form-check">-->
<!--          <el-checkbox-group :disabled="disabled" v-model="formData.products">-->
<!--            <el-checkbox :label="product.productCode" v-for="product in brandOwnerProductList" :key="product.productCode">{{product.productModel}}</el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </div>-->
<!--      </el-form-item>-->

      <el-form-item :label="$t('lang.确认完成')" prop="confirmLangList" v-if="!disabled">
        <div class="form-check">
          <el-checkbox-group  v-model="formData.confirmLangList">
            <el-checkbox :label="lang.value" v-for="lang in langList" :key="'lang_' + lang.value">{{lang.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>

<!--      <el-form-item :label="$t('lang.兼容母包')" prop="compatibleVersion">
        <el-select :disabled="disabled" v-model="formData.compatibleVersion" :placeholder="$t('lang.请选择')">
          <el-option v-for="apk in apkList" :key="'apk_' + apk.value" :label="apk.name" :value="apk.value"></el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item>
        <el-button @click="$router.back()" v-if="disabled">{{ $t('lang.返回') }}</el-button>
        <template v-else>
          <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
          <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
        </template>
        <el-button type="primary" @click="$emit('lastStep')">{{ $t('lang.上一步') }}</el-button>
        <el-button type="primary" @click="$emit('next')"  v-if="disabled">{{ $t('lang.完成') }}</el-button>
        <el-button type="primary" @click="$emit('finish')" v-else>{{ $t('lang.完成') }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {loadDict, loadTagsByLang} from "../../js/common";

export default {
  name: "RecipeInfoForm",
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      formData: {
        tags: [],
        difficultyLevel: '',
        products: [],
        compatibleVersion: '',
        confirmLangList: [],
      },
      test: [],
      checkList: [],
      recipeCategory: [],
      isFirst: true,
      selectLang: [],
      apkList: [],
      disabled: false,
    }
  },
  watch: {
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    },
    formData: {
      handler(obj) {
        this.$store.commit("CHANGE_RECIPE", {...obj});
      },
      immediate: false,
      deep: true,
    },
    lang: {
      async handler(val) {
        if(val) {
          loadTagsByLang(this, val);
        }
      },
      immediate: true,
    }
  },
  methods: {
    handleGetData() {
      let recipe = this.$store.state.recipe;
      this.selectLang = recipe.supportLangList || [];
      for (const key in this.formData) {
        if(Array.isArray(this.formData[key])) {
          this.formData[key] = recipe[key] || [];
        } else if(typeof this.formData[key] == 'object') {
          this.formData[key] = recipe[key] || {};
        } else {
          this.formData[key] = recipe[key] || '';
        }
      }
    },
  },
  computed: {
    supportLangList() {
      return this.$store.state.recipe.supportLangList;
    },
    recipeTagList() {
      return this.$store.state.recipeTagListByLang || [];
    },
    langList() {
      let list = this.$store.state.supportLangList;
      return list.filter(l => this.selectLang.includes(l.value));
    },
    lang() {
      return this.$store.state.recipe.lang;
    },
    brandOwnerProductList() {
      return this.$store.getters.getProductModelByRecipeType;
    }
  },
  async created() {
    this.apkList = await loadDict(this, 'COMPATIBILITY_APK');
  },
  activated() {
    this.handleGetData();
  }
}
</script>

<style scoped>

.form-check {
  width: 700px;
  border: 1px solid #dddddd;
  padding: 8px;
}

.add-row {
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2f86dd;
}

</style>
